import credentials from 'config/credentials';
import request from 'utils/request';
import decodePath from './decodePath';
import gaTrack from './gaTrack';
import { serialize } from '../urlUtils';

function stringifyPoint(wpt) {
  return `point=${wpt.lat.toFixed(5)},${wpt.lng.toFixed(5)}`;
}

async function leg(waypoints, hash) {
  const pointsStr = waypoints.map(stringifyPoint).join('&');
  const options = serialize({
    key: credentials.graphhopper,
    type: 'json',
    instructions: 'false',
    ...hash,
  });
  const url = `https://graphhopper.com/api/1/route?${pointsStr}&${options}`;

  const data = await request(url, {}, gaTrack);

  return data.paths.map(path => decodePath(path.points, 5)).flat();
}

async function graphhopper(waypoints, vehicle) {
  const legs = waypoints
    .slice(0, -1)
    .map((pt, i) => leg([pt, waypoints[i + 1]], vehicle));
  return Promise.all(legs);
}

export default graphhopper;
